
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/org-booking/[id]",
      function () {
        return require("private-next-pages/booking/org-booking/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/org-booking/[id]"])
      });
    }
  